import { createApp } from '@wu/widget-core';
import { meta } from '../constants';
import { Chats } from './Chats';

export const createChat = () => {
  return createApp(meta, Chats);
};
